import { z } from 'zod';
import { ocrReturnFormatSchema } from './ocr';

export const ocrFieldNameSchema = z.enum([
  'idNumber',
  'firstName',
  'lastName',
  'thaiName',
  'address',
  'dateOfBirth',
  'expirationDate',
]);

export const updateConfigurationInputSchema = z.object({
  language: z.enum(['th', 'en']).optional(),
  returnFormat: ocrReturnFormatSchema.optional(),
  selectedFields: z.array(ocrFieldNameSchema).optional(),
  minConfidence: z.number().int().min(0).max(100).optional(),
  retentionDays: z.number().int().min(1).max(90).optional(),
});
